import {hitGoogleTagManager} from "./hit_google_tag_manager";

type quickViewModalVisibilityType = "view" | "close";
type quickViewModalElementType = "right arrow" | "left arrow" | "poi" | "more_details" | "request";

export const gtmQuickViewModalVisibility = (visibility: quickViewModalVisibilityType) => {
    hitGoogleTagManager({event: `quickview_modal_${visibility}`});
};

export const gtmQuickViewModalElement = (element: quickViewModalElementType) => {
    hitGoogleTagManager({event: `quickview_modal_${element}_click`});
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

type quickViewModalVisibilityType = "view" | "close";
type quickViewModalElementType = "right arrow" | "left arrow" | "poi" | "more_details" | "request";

export const gtmQuickViewModalVisibility = (visibility: quickViewModalVisibilityType) => {
    hitGoogleTagManager({event: `quickview_modal_${visibility}`});
};

export const gtmQuickViewModalElement = (element: quickViewModalElementType) => {
    hitGoogleTagManager({event: `quickview_modal_${element}_click`});
};
